import React, {Component} from 'react';
import {connect} from 'react-redux';
import {
  updateHomePageDataFetched,
  updateHomePageFilterModal,
  updateHomePageSortBy,
  updateHomePageDeals,
  updateHomePageFilteredDeals,
  updateHomePagePriceRangeTextBoxes,
  updateHomePageFilterCategories,
  updateHomePageSearchKeyWords,

  updateHomePageSpecsModal,
  updateHomePageCurrentLaptop
} from '../../reducers/homePageReducer';
import {Modal, Input, Icon, Button, Dropdown, Card, Image} from 'semantic-ui-react';
import debounce from 'lodash/debounce';
import uniqBy from 'lodash/uniqBy';
import reduce from 'lodash/reduce';
import orderBy from 'lodash/orderBy';
import {sampleLaptopDeals} from '../../lib/laptop';
import {NavbarFilter} from '../NavbarFilter/NavbarFilter';
import './HomePage.css';

class HomePage extends Component {
  constructor(props) {
    super(props);

    window.mixpanel.track('Homepage Visited', {
    });

    this.handleGetStartedClick = this.handleGetStartedClick.bind(this);
    this.handleHomePageReferralButtonClick = this.handleHomePageReferralButtonClick.bind(this);
    this.handleModalOpen = this.handleModalOpen.bind(this);
    this.handleModalClose = this.handleModalClose.bind(this);

    this.props.updateHomePageCurrentLaptop(sampleLaptopDeals[3]);
  }

  componentDidMount() {
  }

  handleHomePageReferralButtonClick(type, data) {
    const dealDetails = data.dealdetails;
    window.mixpanel.track('HomePage Referral Clicked', {
      title: dealDetails.title,
      link: dealDetails.link,
      manufacturer: dealDetails.manufacturer,
      model: dealDetails.model,
      store: dealDetails.store,
      price: dealDetails.price
    });
  }

  handleModalOpen(type, data) {
    window.mixpanel.track('HomePage Specs Help Clicked', {
    });

    this.props.updateHomePageSpecsModal(true);
  }

  handleModalClose() {
    this.props.updateHomePageSpecsModal(false);
  }

  handleGetStartedClick() {
    window.mixpanel.track('Get Started Clicked', {
    });

    this.props.history.push('/laptopquiz');
  }

  // accepts capacity in GB
  // returns string in either TB or GB
  static beautifyStorage(capacity) {
    if (capacity >= 1000) {
      return (capacity / 1000.0) + ' TB';
    }
    return capacity + ' GB';
  }

  render() {
    const laptopDeal = this.props.homePageCurrentLaptop;

    return <div className="Regular-page Margin-padded ui centered grid">
      <div className="three column row">
        <div className="tablet only computer only three wide column">
        </div>
        <div className="eight wide column">
          <h2 className="ui center aligned header permutize-color">
            Need Help with Purchasing a Laptop?
          </h2>
          <div>
            &nbsp;
          </div>
          <h3 className="ui center aligned header">
            Use our Laptop Genie to find the right one.
          </h3>
          <div className="ui center aligned header">
            <Button size="huge" color="green" onClick={this.handleGetStartedClick}>Get Started</Button>
          </div>
          <div>
            &nbsp;
          </div>
          <h2 className="ui center aligned header permutize-color">
            Deal of the Day
          </h2>
          <div className="ui center aligned header">
            {laptopDeal &&
            <Card centered>
              <Image src={laptopDeal.pictureLink} />
              <Card.Content>
                <Card.Header>
                  <div className="price-label special-price-label">
                    ${laptopDeal.price}
                    {
                      laptopDeal.discount ?
                        <h4 className="discount-label">Save ${laptopDeal.discount} instantly</h4> :
                        <span></span>
                    }
                  </div>
                  <a href={laptopDeal.link} target="_blank" rel="noopener noreferrer">
                    <Button primary onClick={this.handleHomePageReferralButtonClick} dealdetails={laptopDeal}>
                      <Button.Content visible>
                        {laptopDeal.storeDisplayName} <Icon name='shop' />
                      </Button.Content>
                    </Button>
                  </a>
                </Card.Header>
                <Card.Description>
                  <Button onClick={this.handleModalOpen} dealdetails={laptopDeal}>
                    <Button.Content>
                      What do these specs mean?
                    </Button.Content>
                  </Button><br/>
                  {laptopDeal.screen.size}" {laptopDeal.screen.resolution.width}X{laptopDeal.screen.resolution.height} {laptopDeal.screen.panelType} Screen<br/>

                  {laptopDeal.cpu.clockSpeed}GHZ {laptopDeal.cpu.cores}-Core {laptopDeal.cpu.manufacturer} {laptopDeal.cpu.model} Processor<br/>
                  {laptopDeal.ram.size} GB {laptopDeal.ram.sodimm} RAM<br/>

                  {laptopDeal.gpu.type} {laptopDeal.gpu.manufacturer} {laptopDeal.gpu.model}
                  {laptopDeal.gpu.vram ? <span> {laptopDeal.gpu.vram} GB </span> : <span></span>} Graphics<br/>

                  {HomePage.beautifyStorage(laptopDeal.hardDisks[0].size)} {laptopDeal.hardDisks[0].type}
                  {laptopDeal.hardDisks.length > 1 ? <span> + {HomePage.beautifyStorage(laptopDeal.hardDisks[1].size)} {laptopDeal.hardDisks[1].type}</span> : <span></span>}<br/>

                  {laptopDeal.weight} lbs<br/>
                </Card.Description>
              </Card.Content>
            </Card>
            }
          </div>
        </div>
        <div className="tablet only computer only two wide column">
        </div>
      </div>

      <Modal closeIcon size={'mini'} onClose={this.handleModalClose} open={this.props.homePageSpecsModalVisible}>
        <div className="ui centered grid">
          <div className="three column row">

            <div className="three wide column">
            </div>

            <div className="ten wide column">
              {
                this.props.homePageCurrentLaptop && this.props.homePageCurrentLaptop.screen.panelType === 'IPS' &&
                <p>
                  <b>IPS Screen:</b> A type of technology that offers superior viewing angles on your screen.
                  A high viewing angle means less color shift when viewing your screen from an angle.
                  This is desirable for watching movies, and gaming.<br/>
                  <b>This laptop is equipped with an IPS screen.</b>
                </p>
              }
              {
                this.props.homePageCurrentLaptop && this.props.homePageCurrentLaptop.hardDisks[0].type === 'SSD' &&
                <p>
                  <b>SSD:</b> Solid State Srive. This is where your documents, programs, and photos are stored
                  after the computer shuts down.
                  SSDs have no moving parts and are therefore durable and fast.
                  When shopping for a laptop, SSDs are preferred over HDDs.<br/>
                  <b>This laptop is equipped with an SSD.</b>
                </p>
              }
              <p>
                <b>RAM:</b> Random Access Memory. RAM is where programs are stored when the computer is running.
                The more RAM a computer has, the more programs it can run simultaneously.
                We recommend at least 4 GB of RAM for basic computing; 8 GB or more for gaming and
                photo/video editing.<br/>
                <b>This laptop is equipped with {this.props.homePageCurrentLaptop && this.props.homePageCurrentLaptop.ram.size} GB of RAM.</b>
              </p>
              <p>
                <b>GPU:</b> Graphics Processing Unit. This controls how the graphics are displayed on your screen.
                There are 2 types: <b>Integrated</b> and <b>Discrete</b>.
                Integrated is sufficient for most computing needs. However, we recommend a Discrete GPU
                for gaming and video/photo editing.<br/>
                <b>This laptop is equipped with a {this.props.homePageCurrentLaptop && this.props.homePageCurrentLaptop.gpu.type} GPU.</b>
              </p>
              {
                this.props.homePageCurrentLaptop && this.props.homePageCurrentLaptop.weight <= 4 &&
                <p>
                  This laptop weighs <b>{this.props.homePageCurrentLaptop.weight} lbs</b> and is <b>very portable</b>.
                </p>
              }
            </div>

            <div className="three wide column">
            </div>
          </div>
        </div>
      </Modal>
    </div>
  }

}

export default connect(
  (state) => ({
    homePageDataFetched: state.homePage.homePageDataFetched,
    homePageFilterModal: state.homePage.homePageFilterModalVisible,
    homePageSortBy: state.homePage.homePageSortBy,
    homePageDeals: state.homePage.homePageDeals,
    homePageFilteredDeals: state.homePage.homePageFilteredDeals,
    homePagePriceRangeTextBoxes: state.homePage.homePagePriceRangeTextBoxes,
    homePageLaptopCategories: state.homePage.homePageLaptopCategories,
    homePageSearchKeyWords: state.homePage.homePageSearchKeyWords,

    homePageSpecsModalVisible: state.homePage.specsModalVisible,
    homePageCurrentLaptop: state.homePage.currentLaptop
  }),
  {
    updateHomePageDataFetched,
    updateHomePageFilterModal,
    updateHomePageSortBy,
    updateHomePageDeals,
    updateHomePageFilteredDeals,
    updateHomePagePriceRangeTextBoxes,
    updateHomePageFilterCategories,
    updateHomePageSearchKeyWords,

    updateHomePageSpecsModal,
    updateHomePageCurrentLaptop
  }
)(HomePage);


// WEBPACK FOOTER //
// ./src/components/HomePage/HomePage.js